import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
//import { distinctUntilKeyChanged } from 'rxjs/operator/distinctUntilKeyChanged';

class TVChannelPopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
    this.props.show = this.state.modal
  }

  componentDidMount() {
    this.setState(prevState => ({
      modal: this.props.show
    }));
  }

  render() {

    const imgt = "/.galleries/eir/tv/logos/categories/standard/trte.png"
    let logo = Object.values(this.props.tvLogos).sort((a, b) => (parseInt(a.position) > parseInt(b.position)) ? 1 : -1);

    return (

      <div>
        <Modal
          fade={false}
          isOpen={this.state.modal}
          toggle={this.props.toggle}
          className="tv-channels-modal popup eir-fluid-md-w75"
        >
          <ModalHeader
            toggle={this.props.toggle}
            className="eir-icon icon-close--primary"
          >
          </ModalHeader>
          <ModalBody
            className="tv-channels-modal modal-body"
          >
            <Container>
              <Row className="justify-content-center">
                <h5>{this.props.title}</h5>
                <h6 className="mb-0 subtext no-wrap">When it comes to great broadband we have you covered... you get </h6>
                <h6 className="mb-4 subtext">all of these channels FREE with your eir broadband bundle.</h6>
              </Row>
              <Row>
                {logo.map((item,index) => {
                  return (
                    <Col xs="3" sm="2" md="2" className="p-1">
                    <img  className="logo" src={item.filename} alt={item.alt} title={item.title}/>
                  </Col>
                  )
                })}

              </Row>
            </Container>
          </ModalBody>
        </Modal>
      </div>
    );
  }

  

}

export default TVChannelPopUp;